function subscribe(listId, email, params = {}) {
	const config = Object.assign({}, params, {
		g: listId,
		email
	})

	const body = Object.keys(config).reduce((str, key) => {
		str.append(key, config[key])
		return str
	}, new URLSearchParams())

	return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
		method: 'POST',
		headers: {
			"Access-Control-Allow-Headers": "*",
			"Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
		},
		body
	}).then(res => res.json())
}
const backinstockWrapper = document.querySelector('[data-back-in-stock]');
function runBackInStock(params) {
	if (!backinstockWrapper) return;
	const backinstockForm = backinstockWrapper.querySelector('[data-form]');
	if (!backinstockForm) return
	const backinstockSuccess = document.querySelector('[data-bis-success]');
	const formEmail = backinstockForm.querySelector('#bis-email')
	const formNewsletter = backinstockForm.querySelector('#bis-newsletter')
	const formSubmitButton = backinstockForm.querySelector('button[type="submit"]');
	const errorMessage = backinstockForm.querySelector('#bis-error-message');

	backinstockForm.addEventListener('submit', async (e) => {
		e.preventDefault();

		if (formNewsletter.checked === false) {
			errorMessage.style.display = "block"
			return
		}
		errorMessage.style.display = "none"
		const chosenVariantEl = document.querySelector('.product__content .form__width input[name="id"]');
		if (!chosenVariantEl) return;
		let chosenVariant = chosenVariantEl.value;

		formSubmitButton.disabled = true;
		if (chosenVariant === '') {
			formSubmitButton.disabled = false;
			return
		}
		const backInStockURL = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${theme.settings.klaviyoAccount}`
		const dataJSON = JSON.stringify({
			data: {
				type: 'back-in-stock-subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email: formEmail.value
							}
						}
					},
					channels: ["EMAIL"]
				},
				relationships: {
					variant: {
						data: {
							type: 'catalog-variant',
							id: `$shopify:::$default:::${chosenVariant}`
						}
					}
				}
			}
		});

		const options = {
			method: 'POST',
			headers: {
				accept: 'application/vnd.api+json',
				revision: '2025-01-15',
				'content-type': 'application/vnd.api+json'
			},
			body: dataJSON
		}

		const outOfStockDrawer = document.querySelector('#out-of-stock-drawer');

		if (outOfStockDrawer.getAttribute('data-modal-type') !== 'notify-me') {
			try {
				await fetch(backInStockURL, options)
					.then(res => res)
					.catch(err => console.error(err))


				if (formNewsletter.checked) {
					const subscribeURL = `https://a.klaviyo.com/client/subscriptions/?company_id=${theme.settings.klaviyoAccount}`;
					let subscribeOptions;
					subscribeOptions = {
						method: 'POST',
						headers: { revision: '2025-01-15', 'content-type': 'application/vnd.api+json', 'accept': 'application/vnd.api+json' },
						body: JSON.stringify({
							data: {
								type: 'subscription',
								attributes: {
									profile: {
										data: {
											type: 'profile',
											attributes: {
												email: formEmail.value,
												properties: {
													custom_source: 'Back in Stock'
												},
											}
										}
									}
								},
								relationships: { list: { data: { type: 'list', id: theme.settings.klaviyoList } } }
							}
						})
					};
					await fetch(subscribeURL, subscribeOptions)
						.then(res => res)
						.catch(err => console.error('error:' + err));
				}
			}
			catch (e) {
				console.warn("Error:", e)
			}

		}

		backinstockWrapper.classList.remove('is-open');
		formSubmitButton.disabled = false;
		backinstockSuccess.hidden = false;
	})
}
if (backinstockWrapper) runBackInStock();
